import { render } from "./Sources.vue?vue&type=template&id=c437c2f0&scoped=true"
import script from "./Sources.vue?vue&type=script&lang=js"
export * from "./Sources.vue?vue&type=script&lang=js"

import "./Sources.vue?vue&type=style&index=0&id=c437c2f0&lang=scss"
import "./Sources.vue?vue&type=style&index=1&id=c437c2f0&lang=scss&scoped=true"

import exportComponent from "/Users/mymac/Documents/Digitala/Perki/newest-perki/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c437c2f0"]])

export default __exports__